import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "test-patient" }
const _hoisted_2 = {
  key: 1,
  class: "pointer"
}
const _hoisted_3 = {
  key: 2,
  class: "pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_EyeInvisibleOutlined = _resolveComponent("EyeInvisibleOutlined")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_table = _resolveComponent("a-table", true)!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "data-source": _ctx.patients,
      pagination: false
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'firstName')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'PatientProfile', params: { id: record.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(record.firstName) + " " + _toDisplayString(record.lastName), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (column.key === 'specialAttention')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (record.specialAttention)
                  ? (_openBlock(), _createBlock(_component_EyeOutlined, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.markAsSpecial(record, false)),
                      class: "iconStyle"
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_EyeInvisibleOutlined, {
                      key: 1,
                      onClick: ($event: any) => (_ctx.markAsSpecial(record, true)),
                      class: "iconStyle"
                    }, null, 8, ["onClick"]))
              ]))
            : (column.key === 'action')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    to: { name: 'UpdatePatient', params: { id: record.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditOutlined, {
                        style: {"margin-right":"10px"},
                        class: "iconStyle"
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  _createVNode(_component_DeleteOutlined, {
                    onClick: ($event: any) => (_ctx.deletePatient(record.id)),
                    class: "iconStyle"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_a_divider, { type: "vertical" })
                ]))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source"])
  ]))
}